import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./rootReducer";
import { persistStore, persistReducer } from "redux-persist";
import secureStorageAdapter from "./secureStorage";

/**
 * Redux Store Configuration with Enhanced Security
 * - Uses secure sessionStorage instead of localStorage
 * - Disables Redux DevTools in production
 * - Implements encrypted storage for sensitive data
 */

// Only enable DevTools in development
const reduxDevTool =
  process.env.NODE_ENV === "development"
    ? composeWithDevTools(applyMiddleware(thunk.withExtraArgument()))
    : compose(applyMiddleware(thunk.withExtraArgument()));

// Persist configuration with secure storage
const persistConfig = {
  key: "root",
  storage: secureStorageAdapter, // Use secure encrypted sessionStorage
  whitelist: ["user"], // Only persist user data
  blacklist: [], // Don't persist sensitive temporary data
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store
export const store = createStore(persistedReducer, reduxDevTool);

// Create persistor
export const persistor = persistStore(store);

// Disable Redux DevTools in production
if (process.env.NODE_ENV === "production" && window.__REDUX_DEVTOOLS_EXTENSION__) {
  window.__REDUX_DEVTOOLS_EXTENSION__ = undefined;
}

export default store;
